import { combineReducers } from 'redux'
import listReducer, { listActions } from '@app-store/slices/tags/list'
import createTagReducer, { createTagActions } from '@app-store/slices/tags/create'
import createTagByAdminReducer, { createTagByAdminActions } from '@app-store/slices/tags/createByAdmin'
import deleteTagReducer, { deleteTagActions } from '@app-store/slices/tags/delete'
import editTagReducer, { editTagActions } from '@app-store/slices/tags/edit'
export const tagsReducer = combineReducers({
    list: listReducer,
    create: createTagReducer,
    createByAdmin: createTagByAdminReducer,
    delete: deleteTagReducer,
    edit: editTagReducer
})

export const tagsActions = {
    list: listActions,
    create: createTagActions,
    createByAdmin: createTagByAdminActions,
    delete: deleteTagActions,
    edit: editTagActions
}
